module.exports = __webpack_public_path__ + "static/media/lykke14.e18a0f7c.jpg";